import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { ComponentProps } from "react";

import { IMedicalFormItemConfigProps, IMedicalFormItemProps } from "../../Types/IMedicalFormItemProps";
import BaseComposableFormItem, { IBaseComposableFormItemProps } from "./BaseComposableFormItem";

type YesOrNo = "yes" | "no";

const ToggleFormElement: React.FC<ComponentProps<IBaseComposableFormItemProps["FormElement"]>> = ({
  value,
  onChange,
  disabled
}) => (
  <ToggleButtonGroup
    className="medicalStep-answerToggle"
    color="primary"
    value={(value === null ? undefined : value === "true" ? "yes" : value === "false" ? "no" : null) as YesOrNo}
    exclusive
    disabled={disabled}
    onChange={(_: unknown, value: YesOrNo) => onChange(value === "yes" ? "true" : "false")}
  >
    <ToggleButton className="medicalStep-yesButton" value="yes">
      Yes
    </ToggleButton>
    <ToggleButton className="medicalStep-noButton" value="no">
      No
    </ToggleButton>
  </ToggleButtonGroup>
);

const YesNoToggleFormItem: React.FC<IMedicalFormItemConfigProps & IMedicalFormItemProps> = props => (
  <BaseComposableFormItem {...props} FormElement={ToggleFormElement} />
);

export default YesNoToggleFormItem;
